import { SendVariantOutlineIcon } from './SendVariantOutlineIcon';

/**
 * author: Google
 * id 5F6A5994-FF0D-417E-9845-8BF18225CE3C
 * name send-variant-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-variant-outline.svg
 * tags
 */
export const PaperAirplaneVariantOutlineIcon = SendVariantOutlineIcon;
export default PaperAirplaneVariantOutlineIcon